import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const formControl = (props, context) => {
  const {
    label, edit, info, value, updateValue, hasError, ...rest
  } = props;
  const { readOnly } = rest;

  const id = `input_${props.id}`;
  const inputEl = useRef();
  const showLabel = label && !readOnly;
  const type = props.type || 'text';
  const [error, setError] = useState(false);
  const [valueInput, setValueInput] = useState(value);
  const validation = (e) => {
    const inputError = !e.target.checkValidity();
    setError(inputError);
    hasError(inputError);
  };
  const onChange = (e) => {
    const changedValue = e.target.value;
    setValueInput(changedValue);
    updateValue(changedValue);
    hasError(error);
  };
  // watch changes on "readOnly" state, on change state,
  // if we toggle and has an error, return to previous state and remove error
  useEffect(() => {
    if (error) {
      setValueInput(value);
      setError(false);
    }
  }, [readOnly]);
  //   if we dont have placeholder, return null, since placeholder is the key of the element
  if (!value && readOnly) {
    return null;
  }

  return (
    <div className={`FormControl mt-2 ${error ? 'error' : ''}`}>
          {showLabel && (
            <label htmlFor={id} className="form-label">
              {label}
            </label>
          )}
          <input
            {...rest}
            className="form-input"
            id={id}
            type={type}
            ref={inputEl}
            value={valueInput}
            onBlur={validation}
            readOnly={readOnly}
            onFocus={() => setError(false)}
            onChange={onChange}
          />
          {error && (
            <small className="text-status-red">
              {context.t('Incorrect data, check the {label}', {
                label,
              })}
            </small>
          )}
          {!error && <small>{info}</small>}
    </div>
  );
};

formControl.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default formControl;
